import { createContext, useContext, useState } from "react";

const LocationContext = createContext();

export const LocationProvider = ({ children }) => {
  const [locationDetails, setLocationDetails] = useState(null);

  return (
    <LocationContext.Provider value={{ locationDetails, setLocationDetails }}>
      {children}
    </LocationContext.Provider>
  );
};

//Custom hook for convenience
export const useLocation = () => {
  const context = useContext(LocationContext);
  
  if (!context) {
    throw new Error("useLocation must be used within a LocationProvider");
  }

  return context;
};
